


































import {Component, Prop, Vue} from 'vue-property-decorator';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import {IMenuOption} from '@/store/modules/menu.store';
import {WebService} from '@/services/web.service';

@Component({
	components: {
		typeahead: VueBootstrapTypeahead,
	},
})
export default class AddExistingOption extends Vue {
	@Prop({required: true})
	menuId!: string;

	@Prop({required: true})
	itemId!: string;

	showOverlay = false;
	search = '';
	options: IMenuOption[] = [];
	showLoadingOverlay = false;

	close() {
		this.showOverlay = false;
	}

	serializeItem(input: {name: string}) {
		return input.name;
	}

	finalClose() {
		this.$emit('close');
	}

	choicesString(option: IMenuOption) {
		return Object.values(option.choices).map((choice) => {
			return choice.name;
		}).join(', ');
	}

	async created() {
		this.showLoadingOverlay = true;
		this.options = await WebService.getOptions() as IMenuOption[];
		this.showLoadingOverlay = false;
	}

	async selectedItem(option: IMenuOption) {
		console.log(option);
		try {
			this.showLoadingOverlay = true;
			await WebService.addOptionToItem(this.menuId, this.itemId, option.optionId);
			this.showLoadingOverlay = false;
			this.close();
		} catch(e) {
			this.showLoadingOverlay = false;
			await this.$bvModal.msgBoxOk( 'There was a problem adding your modifier to the item.', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}
}
